var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-fade" } }, [
    _vm.isOpen
      ? _c("div", { staticClass: "detail-popup" }, [
          _c("div", { staticClass: "detail-popup__wrapper" }, [
            _c(
              "div",
              { staticClass: "detail-popup__content" },
              [
                _c("div", { staticClass: "detail-popup__specs" }, [
                  _vm.flat.area
                    ? _c("div", { staticClass: "detail-popup__specs-item" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.flat.area) +
                            " м"
                        ),
                        _c("sup", [_vm._v("2")])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flat.title
                    ? _c("div", { staticClass: "detail-popup__specs-item" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.computedType) +
                            " №" +
                            _vm._s(_vm.flat.title) +
                            "\n                    "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.flat.price
                  ? _c("div", { staticClass: "detail-popup__price" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            Number(_vm.flat.price)
                              ? _vm.convertToDigit(_vm.flat.price) + " ₽"
                              : _vm.flat.price
                          ) +
                          "\n                "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("ButtonClose", {
                  attrs: {
                    modify: "button-close_theme_parametric detail-popup__close"
                  },
                  on: { click: _vm.closeOpen }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "detail-popup__plan" }, [
                  _c("img", {
                    attrs: { src: _vm.flat.plan, alt: _vm.flat.title }
                  })
                ]),
                _vm._v(" "),
                _c("transition", { attrs: { name: "slide-fade" } }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "button button_theme_parametric button_theme_black detail-popup__more",
                      attrs: { href: _vm.flat.link, type: "button" }
                    },
                    [_c("span", [_vm._v("Подробнее")])]
                  )
                ])
              ],
              1
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }